<template>
  <div>
    <va-modal
      :value="isOpen"
      :okText="$t('reports.reports.buttons.save')"
      :okClass="'btn btn-primary btn-micro'"
      :okToClose="false"
      @ok="submit"
      :cancelText="$t('reports.templates.buttons.back')"
      :cancelClass="'btn-cancelar btn btn-primary btn-micro'"
      @cancel="close"
      size="large"
     >

      <div slot="header" class="modal-title">
        <span>{{ isUpdate ? $t('reports.templates.titles.update_modal') : $t('reports.templates.titles.create_modal') }}</span>
      </div>

      <div class="evollu-form">
        <h5>
          <b>{{ $t('reports.templates.titles.report_info') }}</b>
        </h5>

        <div class="row">
          <!-- Input for: name -->
          <div class="col-12 col-md-6 mb-3">
            <va-input
              id="template-name"
              :label="$t('reports.templates.labels.name')"
              v-model="form.data.name"
              placeholder="---"
              @input="form.errors.clear('name')"
              :error="form.errors.has('name')"
              :error-messages="[$t(form.errors.get('name'))]"
            />
          </div>

          <!-- Checkbox is control -->
          <div class="col-12 col-md-6 pt-4 mb-3">
            <va-checkbox
              class="col"
              v-model="form.data.is_control"
              :label="$t('reports.templates.labels.is_control')"
            />
          </div>
        </div>
        <div class="row">
          <!-- Input for: report_type -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">{{$t('reports.templates.labels.report_type')}}:</label>
            <multiselect
              id="report-type-multiselect"
              v-model="form.data.report_type"
              :options="reportTypes"
              track-by="id"
              label="name"
              select-label=""
              :placeholder="$t('reports.templates.labels.multiselect.report_type_placeholder')"
              deselect-label="×"
              open-direction="bellow"
              @select="form.errors.clear('report_type_id')"
              :allow-empty="false"
              :multiple="false">
              <template slot="option" slot-scope="props">
                {{ $t(props.option.name) }}
              </template>
              <template slot="singleLabel" slot-scope="option">
                {{ $t(option.option.name) }}
              </template>
            </multiselect>
            <small v-show="form.errors.has('report_type_id')"  class="help text-danger">
              {{ $t(form.errors.get('report_type_id')) }}
            </small>
          </div>

          <!-- Input for: client type -->
          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">{{$t('reports.templates.labels.client_type')}}:</label>
            <multiselect
              id="client-type-multiselect"
              v-model="form.data.client_type"
              :options="reportClientTypes"
              track-by="id"
              label="name"
              select-label=""
              :placeholder="$t('reports.templates.labels.multiselect.report_client_type_placeholder')"
              deselect-label="×"
              open-direction="bellow"
              @select="form.errors.clear('client_type_id')"
              :allow-empty="false"
              :multiple="false">
              <template slot="option" slot-scope="props">
                {{ $t(props.option.name) }}
              </template>
              <template slot="singleLabel" slot-scope="option">
                {{ $t(option.option.name) }}
              </template>
            </multiselect>
            <small v-show="form.errors.has('client_type_id')"  class="help text-danger">
              {{ $t(form.errors.get('client_type_id')) }}
            </small>
          </div>
        </div>

        <h5><b>{{$t('reports.templates.titles.report_facilities')}}</b></h5>

        <div class="row">
          <!-- Input for: clients -->
          <div class="col-12 col-md-8 mb-3">
            <label class="form-label">{{$t('reports.templates.labels.clients')}}:</label>
            <multiselect
              id="clients-multiselect"
              v-model="form.data.entities"
              :options="clientOptions"
              track-by="id"
              label="name"
              select-label=""
              :placeholder="$t('reports.templates.labels.multiselect.clients_placeholder')"
              deselect-label="×"
              open-direction="bellow"
              @select="form.errors.clear('entities')"
              :allow-empty="true"
              :limit="5"
              :multiple="true"
              @input="onInputClients">

              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span>{{ formatedEntityName(option) }}&nbsp;<span v-if="option.isCluster"> 📂 ({{`${option.aggregatedData.length} ${$t('reports.templates.labels.entities')}`}})</span></span>
                  <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <span>{{ formatedEntityName(props.option) }}<span v-if="props.option.isCluster"> 📂 ({{`${props.option.aggregatedData.length} ${$t('reports.templates.labels.entities')}`}})</span></span>
              </template>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="form.data.entities.length" @mousedown.prevent.stop="form.data.entities = []"></div>
              </template>
            </multiselect>
            <small v-show="form.errors.has('entities')"  class="help text-danger">
              {{ $t(form.errors.get('entities')) }}
            </small>
          </div>


          <!-- Audiology Providers Filter -->
          <div class="col-12 col-md-4">
            <label class="form-label">{{$t('agenda.screenings.labels.audiology_providers')}}:</label>
            <multiselect
              :options="availableAudProviders"
              v-model="form.data.aud_provider"
              track-by="id"
              label="name"
              select-label=""
              selected-label=""
              deselect-label="×"
              :custom-label="formatedEntityName"
              :placeholder="$t('agenda.screenings.labels.all_entities')"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :limit="10"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')">
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="form.data.aud_provider && form.data.aud_provider !== undefined" @mousedown.prevent.stop="form.data.aud_provider = undefined"></div>
              </template>
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
            </multiselect>
          </div>
        </div>

        <div class="row">
          <!-- Input for: facilities -->
          <div class="col-12 col-md-8 mb-3">
            <label class="form-label">{{$t('reports.templates.labels.facilities')}}:</label>
            <multiselect
              id="facilities-multiselect"
              v-model="form.data.facilities"
              :options="facilitiesOptions"
              track-by="id"
              label="name"
              select-label=""
              :placeholder="$t('reports.templates.labels.multiselect.facilities_placeholder')"
              deselect-label="×"
              open-direction="bellow"
              @select="form.errors.clear('facilities')"
              :allow-empty="true"
              :limit="5"
              :multiple="true"
              @input="onInputFacilities">

              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span>{{ formatedFacilityName(option, false) }}&nbsp;<span v-if="option.isCluster"> 📂 ({{`${option.aggregatedData.length} ${$t('reports.templates.labels.facilities')}`}})</span></span>
                  <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <span>{{ formatedFacilityName(props.option) }}<span v-if="props.option.isCluster"> 📂 ({{`${props.option.aggregatedData.length} ${$t('reports.templates.labels.facilities')}`}})</span></span>
              </template>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="form.data.facilities.length" @mousedown.prevent.stop="form.data.facilities = []"></div>
              </template>
            </multiselect>
            <small v-show="form.errors.has('facilities')"  class="help text-danger">
              {{ $t(form.errors.get('facilities')) }}
            </small>
          </div>
        </div>

        <h4><b>{{$t('reports.templates.titles.report_data')}}</b></h4>

        <h5 v-if="!isActionReport" ><b>{{ $t('reports.templates.subtitles.monthly_fee') }}</b></h5>

        <div class="row" v-if="!isActionReport">
          <!-- Input for: fee_description -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-fee-description"
              :label="$t('reports.templates.labels.fee_desc')"
              v-model="form.data.fee_desc"
              placeholder="---"
              @input="form.errors.clear('fee_desc')"
              :error="form.errors.has('fee_desc')"
              :error-messages="[$t(form.errors.get('fee_desc'))]"
            />
          </div>

          <!-- Input for: fee -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-fee"
              :label="$t('reports.templates.labels.fee')"
              v-model="form.data.fee"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('fee')"
              :error="form.errors.has('fee')"
              :error-messages="[$t(form.errors.get('fee'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <h5><b>{{ $t('reports.templates.subtitles.main_fees') }}</b></h5>

        <div class="row">
          <!-- Input for: per_promotion_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-per-promotion-description"
              :label="$t('reports.templates.labels.per_promotion_desc')"
              v-model="form.data.per_promotion_desc"
              placeholder="---"
              @input="form.errors.clear('per_promotion_desc')"
              :error="form.errors.has('per_promotion_desc')"
              :error-messages="[$t(form.errors.get('per_promotion_desc'))]"
            />
          </div>

          <!-- Input for: per_promotion -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-per-promotion"
              :label="$t('reports.templates.labels.per_promotion')"
              v-model="form.data.per_promotion"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('per_promotion')"
              :error="form.errors.has('per_promotion')"
              :error-messages="[$t(form.errors.get('per_promotion'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <div class="row">
          <!-- Input for: per_kiosk_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-per-kiosk-description"
              :label="$t('reports.templates.labels.per_kiosk_desc')"
              v-model="form.data.per_kiosk_desc"
              placeholder="---"
              @input="form.errors.clear('per_kiosk_desc')"
              :error="form.errors.has('per_kiosk_desc')"
              :error-messages="[$t(form.errors.get('per_kiosk_desc'))]"
            />
          </div>

          <!-- Input for: per_kiosk -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-per-kiosk"
              :label="$t('reports.templates.labels.per_kiosk')"
              v-model="form.data.per_kiosk"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('per_kiosk')"
              :error="form.errors.has('per_kiosk')"
              :error-messages="[$t(form.errors.get('per_kiosk'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <div class="row">
          <!-- Input for: per_license_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-per-license-description"
              :label="$t('reports.templates.labels.per_license_desc')"
              v-model="form.data.per_license_desc"
              placeholder="---"
              @input="form.errors.clear('per_license_desc')"
              :error="form.errors.has('per_license_desc')"
              :error-messages="[$t(form.errors.get('per_license_desc'))]"
            />
          </div>

          <!-- Input for: per_license -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-per-license"
              :label="$t('reports.templates.labels.per_license')"
              v-model="form.data.per_license"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('per_license')"
              :error="form.errors.has('per_license')"
              :error-messages="[$t(form.errors.get('per_license'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <h5><b>{{ $t('reports.templates.subtitles.leads_fees') }}</b></h5>

        <div class="row">
          <!-- Input for: per_lq_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-per-lq-description"
              :label="$t('reports.templates.labels.per_lq_desc')"
              v-model="form.data.per_lq_desc"
              placeholder="---"
              @input="form.errors.clear('per_lq_desc')"
              :error="form.errors.has('per_lq_desc')"
              :error-messages="[$t(form.errors.get('per_lq_desc'))]"
            />
          </div>

          <!-- Input for: per_lq -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-per-lq"
              :label="$t('reports.templates.labels.per_lq')"
              v-model="form.data.per_lq"
              placeholder="---"
              step="0.01"
              type="text"
              @input="form.errors.clear('per_lq')"
              :error="form.errors.has('per_lq')"
              :error-messages="[$t(form.errors.get('per_lq'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <div class="row">
          <!-- Input for: per_lqe_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-per-lqe-description"
              :label="$t('reports.templates.labels.per_lqe_desc')"
              v-model="form.data.per_lqe_desc"
              placeholder="---"
              @input="form.errors.clear('per_lqe_desc')"
              :error="form.errors.has('per_lqe_desc')"
              :error-messages="[$t(form.errors.get('per_lqe_desc'))]"
            />
          </div>

          <!-- Input for: per_lqe -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-per-lqe"
              :label="$t('reports.templates.labels.per_lqe')"
              v-model="form.data.per_lqe"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('per_lqe')"
              :error="form.errors.has('per_lqe')"
              :error-messages="[$t(form.errors.get('per_lqe'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <h5><b>{{ $t('reports.templates.subtitles.sales_fees') }}</b></h5>

        <div class="row">
          <!-- Input for: perc_sale_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-perc-sale-description"
              :label="$t('reports.templates.labels.perc_sale_desc')"
              v-model="form.data.perc_sale_desc"
              placeholder="---"
              @input="form.errors.clear('perc_sale_desc')"
              :error="form.errors.has('perc_sale_desc')"
              :error-messages="[$t(form.errors.get('perc_sale_desc'))]"
            />
          </div>

          <!-- Input for: perc_sale -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-perc-sale"
              :label="$t('reports.templates.labels.perc_sale')"
              v-model="form.data.perc_sale"
              placeholder="---"
              type="text"
              @input="form.errors.clear('perc_sale')"
              :error="form.errors.has('perc_sale')"
              :error-messages="[$t(form.errors.get('perc_sale'))]">
              <template slot="append">
                <i class="mr-2 fa fa-percent icon-right input-icon"></i>
              </template>
            </va-input>

          </div>
        </div>

        <div class="row">
          <!-- Input for: per_sale_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-per-sale-description"
              :label="$t('reports.templates.labels.per_sale_desc')"
              v-model="form.data.per_sale_desc"
              placeholder="---"
              @input="form.errors.clear('per_sale_desc')"
              :error="form.errors.has('per_sale_desc')"
              :error-messages="[$t(form.errors.get('per_sale_desc'))]"
            />
          </div>

          <!-- Input for: per_sale -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-per-sale"
              :label="$t('reports.templates.labels.per_sale')"
              v-model="form.data.per_sale"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('per_sale')"
              :error="form.errors.has('per_sale')"
              :error-messages="[$t(form.errors.get('per_sale'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>
          </div>
        </div>

        <h5 v-if="isActionReport"><b>{{ $t('reports.templates.subtitles.action_fees') }}</b></h5>

        <div class="row" v-if="isActionReport">
          <!-- Input for: insurance_fee_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-insurance-fee-desc"
              :label="$t('reports.templates.labels.insurance_fee_desc')"
              v-model="form.data.insurance_fee_desc"
              placeholder="---"
              @input="form.errors.clear('insurance_fee_desc')"
              :error="form.errors.has('insurance_fee_desc')"
              :error-messages="[$t(form.errors.get('insurance_fee_desc'))]"
            />
          </div>

          <!-- Input for: insurance_fee -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-insurance-fee"
              :label="$t('reports.templates.labels.insurance_fee')"
              v-model="form.data.insurance_fee"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('insurance_fee')"
              :error="form.errors.has('insurance_fee')"
              :error-messages="[$t(form.errors.get('insurance_fee'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>
          </div>
        </div>

        <div class="row" v-if="isActionReport">
          <!-- Input for: meal_fee_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-meal-fee-desc"
              :label="$t('reports.templates.labels.meal_fee_desc')"
              v-model="form.data.meal_fee_desc"
              placeholder="---"
              @input="form.errors.clear('meal_fee_desc')"
              :error="form.errors.has('meal_fee_desc')"
              :error-messages="[$t(form.errors.get('meal_fee_desc'))]"
            />
          </div>

          <!-- Input for: meal_fee -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-meal-fee"
              :label="$t('reports.templates.labels.meal_fee')"
              v-model="form.data.meal_fee"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('meal_fee')"
              :error="form.errors.has('meal_fee')"
              :error-messages="[$t(form.errors.get('meal_fee'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>
          </div>
        </div>

        <div class="row" v-if="isActionReport">
          <!-- Input for: travel_fee_desc -->
          <div class="col-12 col-md-8 mb-3">
            <va-input
              id="simple-input-travel-fee-desc"
              :label="$t('reports.templates.labels.travel_fee_desc')"
              v-model="form.data.travel_fee_desc"
              placeholder="---"
              @input="form.errors.clear('travel_fee_desc')"
              :error="form.errors.has('travel_fee_desc')"
              :error-messages="[$t(form.errors.get('travel_fee_desc'))]"
            />
          </div>

          <!-- Input for: travel_fee -->
          <div class="col-12 col-md-3 mb-3">
            <va-input
              id="simple-input-travel-fee"
              :label="$t('reports.templates.labels.travel_fee')"
              v-model="form.data.travel_fee"
              placeholder="---"
              type="text"
              step="0.01"
              @input="form.errors.clear('travel_fee')"
              :error="form.errors.has('travel_fee')"
              :error-messages="[$t(form.errors.get('travel_fee'))]">
              <template slot="append">
                <i class="mr-2 fa fa-euro icon-right input-icon"></i>
              </template>
            </va-input>
          </div>
        </div>
     </div>

    </va-modal>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import { ReportTemplatesService } from '@/api/ReportsService'
import Errors from '@/utils/StandardErrors.js'
import {mapGetters} from "vuex";

const transitionDuration = 500

export default {
  props: {
    serviceUrl: {
      type: String,
      required: true
    },
    reportTemplate: {
      type: Object,
      required: false
    },
    entities: {
      type: Array,
      required: true
    },
    facilities: {
      type: Array,
      required: true
    },
    clusters: {
      type: Array,
      required: true,
    }
  },
  components: {
    Multiselect
  },
  created: function () {
    if (this.isUpdate) {
      this.prepareForUpdate()
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  data: function () {
    return {
      isOpen: false,
      reportTypes: [
        { id: 1, name: 'reports.templates.labels.report_types.monthlyView' },
        { id: 2, name: 'reports.templates.labels.report_types.actionView' }
      ],
      reportClientTypes: [
        { id: 1, name: 'reports.templates.labels.client_types.client' },
        { id: 2, name: 'reports.templates.labels.client_types.provider' }
      ],
      form: {
        data: {
          name: undefined,
          is_control: false,
          report_type: undefined,
          client_type: undefined,
          fee: undefined,
          fee_desc: undefined,
          per_promotion: undefined,
          per_promotion_desc: undefined,
          per_kiosk: undefined,
          per_kiosk_desc: undefined,
          per_license: undefined,
          per_license_desc: undefined,
          per_lq: undefined,
          per_lq_desc: undefined,
          per_lqe: undefined,
          per_lqe_desc: undefined,
          perc_sale: undefined,
          perc_sale_desc: undefined,
          per_sale: undefined,
          per_sale_desc: undefined,
          insurance_fee: undefined,
          insurance_fee_desc: undefined,
          meal_fee: undefined,
          meal_fee_desc: undefined,
          travel_fee: undefined,
          travel_fee_desc: undefined,
          entities: [],
          entity_cluster: undefined,
          facilities: [],
          facility_cluster: undefined,
          aud_providers: undefined
        },
        errors: new Errors()
      }
    }
  },
  computed: {
    ...mapGetters({
      availableAudProviders: 'availableAudProviders',
    }),
    clientOptions: function () {
      let options = []
      if (this.clusters.length > 0) {
        options.push({ name: this.$t('reports.templates.labels.multiselect.clusters').toUpperCase(), $isDisabled: true })
        options = options.concat(this.clusters.map(cluster => {
          return {
            id: cluster.id,
            uid: `c${cluster.id}`,
            name: cluster.name,
            isCluster: true,
            aggregatedData: cluster.entities.map(entity => {
              return {
                id: entity.id,
                uid: `e${entity.id}`,
                name: entity.name,
                cities: entity.cities,
                isCluster: false
              }
            })
          }
        }))
        options.push({ name: this.$t('reports.templates.labels.multiselect.entities').toUpperCase(), $isDisabled: true })
      }

      if (this.entities.length > 0) {
        options = options.concat(this.entities.map(entity => {
          return {
            id: entity.id,
            uid: `e${entity.id}`,
            name: entity.name,
            cities: entity.cities,
            isCluster: false
          }
        }))
      }
      return options
    },
    facilitiesOptions: function () {
      let options = []
      if (this.clusters.length > 0) {
        options.push({ name: this.$t('reports.templates.labels.multiselect.clusters').toUpperCase(), $isDisabled: true })
        options = options.concat(this.clusters.map(cluster => {
          return {
            id: cluster.id,
            uid: `c${cluster.id}`,
            name: cluster.name,
            isCluster: true,
            aggregatedData: [].concat(...cluster.entities.map(entity => {
              return entity.facilities.map(facility => {
                return {
                  id: facility.id,
                  uid: `f${facility.id}`,
                  entity_id: facility.entity_id,
                  name: facility.name,
                  isCluster: false
                }
              })
            }))
          }
        }))
        options.push({
          name: this.$t('reports.templates.labels.multiselect.facilities').toUpperCase(),
          $isDisabled: true
        })
      }

      options = options.concat(this.facilities.map(facility => {
        return {
          id: facility.id,
          uid: `f${facility.id}`,
          entity_id: facility.entity_id,
          name: facility.name,
          city: facility.address && facility.address.city ? facility.address.city : undefined,
          isCluster: false
        }
      }))
      return options
    },
    isUpdate: function () {
      return this.reportTemplate && Object.keys(this.reportTemplate).length > 0
    },
    isActionReport: function () {
      if (!this.form.data.report_type) {
        return false
      }
      return this.form.data.report_type.id === this.reportTypes[1].id
    }
  },
  methods: {
    prepareForUpdate: function () {
      this.form.data = JSON.parse(JSON.stringify(this.reportTemplate))
      this.form.data.report_type = this.reportTypes[this.form.data.report_type - 1]
      this.form.data.client_type = this.reportClientTypes[this.form.data.client_type - 1]

      if (this.form.data.aud_provider) {
        this.form.data.aud_provider = this.availableAudProviders.filter(ap => ap.id === this.form.data.aud_provider)
      }
      if (this.form.data.entity_cluster) {
        this.form.data.entity_cluster.isCluster = true
        this.form.data.entities.push(this.form.data.entity_cluster)
      }

      if (this.form.data.facility_cluster) {
        this.form.data.facility_cluster.isCluster = true
        this.form.data.facilities.push(this.form.data.facility_cluster)
      }
      delete this.form.data.created_by
    },
    close: function () {
      setTimeout(() => {
        this.$emit('modalWasClosed')
      }, transitionDuration)
    },
    submit: function () {
      let data = this.getFormData()
      let request = this.isUpdate ? ReportTemplatesService.update(this.reportTemplate.id, data) : ReportTemplatesService.store(data)

      request
        .then(response => {
          this.$emit('onCreateOrUpdate', { method: this.form.method, data: response.data.data })
          this.isOpen = false
        })
        .catch(errors => {
          if (errors.response.status === 403 && errors.response.data.hasOwnProperty('message')) {
            this.showToast(this.$t(`reports.templates.messages.${errors.response.data.message}`), this.$store.state.errorToastOptions)
          } else if (errors.response.status === 422) {
            this.form.errors.record(errors.response.data, 'reports.templates.errors.')
            this.showToast(this.$t('reports.templates.messages.unsuccessful_store'), this.$store.state.errorToastOptions)
          }
        })
    },

    getFormData: function () {
      let data = JSON.parse(JSON.stringify(this.form.data))
      Object.keys(data).forEach((key) => {
        let value = data[key]
        if (value && (typeof value === 'number' || typeof value === 'string')) {
          value = value.toString().trim()
          let match = value.match('^(\\d+(?:[\\.\\,]\\d{1,5})?)$')
          if (match && match.length && match.length > 0) {
            value = value.toString().replace(',', '.')
          }
          data[key] = value
        }
      })
      if (data.entity_cluster) {
        data.entity_cluster_id = data.entity_cluster.id
        delete data.entities
      } else {
        data.entities = data.entities.map(entity => entity.id)
      }

      if (data.aud_provider) {
        data.aud_provider = data.aud_provider.id
      } else {
        data.aud_provider = null
      }

      delete data.entity_cluster

      if (data.facility_cluster) {
        data.facility_cluster_id = data.facility_cluster.id
        delete data.facilities
      } else {
        data.facilities = data.facilities.map(facility => facility.id)
      }

      delete data.facility_cluster

      if (data.client_type) {
        data.client_type = data.client_type.id
      }

      if (data.report_type) {
        data.report_type_id = data.report_type.id
        delete data.report_type
      }

      return data
    },
    onInputClients: function (newValue) {
      this.form.data.entities = this.unfoldClusters(newValue, 'entity_cluster')
    },
    onInputFacilities: function (newValue) {
      this.form.data.facilities = this.unfoldClusters(newValue, 'facility_cluster')
    },
    unfoldClusters: function (newValue, property) {
      let clusters = 0 // Index of clusters

      for (let i = 0; i < newValue.length; i++) {
        if (newValue[i].isCluster) {
          clusters++
        }
      }

      let finalValues = []
      let uniqueIds = {}

      if (clusters === 1 && newValue.length === 1) {
        this.form.data[property] = newValue[0]
        finalValues.push(newValue[0])
      } else {
        this.form.data[property] = undefined
        newValue.forEach(element => {
          if (element.isCluster) {
            finalValues = finalValues.concat(element.aggregatedData.filter(data => {
              if (!uniqueIds[data.id]) {
                uniqueIds[data.id] = true
                return true
              }
              return false
            }))
          } else {
            if (!uniqueIds[element.id]) {
              uniqueIds[element.id] = true
              finalValues.push(element)
            }
          }
        })
      }

      return finalValues
    },
    formatedEntityName: function (entity) {
      let name = entity.name
      if (entity.cities && entity.cities.length > 0) {
        name += ` (${entity.cities.join(', ')})`
      }
      return name
    },
    formatedFacilityName: function (facility) {
      let name = facility.name
      if (facility.city) {
        name += ` (${facility.city})`
      }
      return name
    }
  }
}
</script>
<style scoped lang="scss">

</style>
